// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1Qi8v","errorLogs":"styles_errorLogs__2bXzi"};